import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { tripModePropType } from '../trip/trip-mode-prop-type'
import { fuelTypePropType } from './fuel-type-prop-type'

/**
 * @typedef {Object} Standstill
 *
 * @property {number}               [carbonFootprint]      - The carbon footprint of the trip in grams.
 * @property {Id}                   [driverId]             - The ID of the driver.
 * @property {ISO8601}              [endTime]              - The end date of the standstill (ISO8601).
 * @property {number}               [fuelConsumption]      - The fuel consumed during the standstill in milliliters.
 * @property {FuelType}             [fuelType]             - The fuel type used by the corresponding vehicle.
 * @property {LocationDescription}  [locationDescription]  - The location description of the point of the standstill.
 * @property {Id}                   [objectId]             - The ID of the object.
 * @property {Position}             [position]             - The geo position of the point of the standstill (decimal degree).
 * @property {Id}                   [positionAddressId]    - The ID of the address at the point of the standstill.
 * @property {Id}                   [standstillId]         - The ID of the standstill.
 * @property {ISO8601}              [startTime]            - The start date of the standstill (ISO8601).
 * @property {TripMode}             [tripMode]             - The trip mode of the standstill.
 * @property {number}               [duration]             - The duration of the standstill in seconds.
 */
export const standstillPropType = PropTypes.shape({
    carbonFootprint: PropTypes.number,
    driverId: idPropType,
    duration: PropTypes.number,
    endTime: iso8601PropType,
    fuelConsumption: PropTypes.number,
    fuelType: fuelTypePropType,
    locationDescription: locationDescriptionPropType,
    objectId: idPropType,
    position: positionPropType,
    positionAddressId: idPropType,
    standstillId: idPropType,
    startTime: iso8601PropType,
    tripMode: tripModePropType
})
